export const overrides = theme => ({
  root: {
    fontSize: theme.typography.body1.fontSize,
  },
})
